import React, { FC } from 'react';
import { MIXPANEL_EVENT_IDENTIFIERS, MIXPANEL_EVENT_TYPES } from '../../../../constans/mixpanel-contants';
import { ModalTypes } from '../../../../constans/modal.constants';
import { getMixpanelService } from '../../../../utils/services/mixpanel-service-instance';
import Modal from '../../../shared/modal/modal';
import Notification from '../../../shared/notification/notification';
import { NOTIFICATION_INTERVAL } from '../../../../constans/common-constants';

export interface ReviewModePopupsProps {
  isConfirmationRequired: boolean;
  toggleReviewMode: () => void;
  presentationId: string | null;
  isShowReviewModePopUp: boolean;
  confirmReviewModeChange: (presentationId: string | null) => void;
  applyReviewModeChanges: (value?: boolean) => void;
  tmpReviewModeState: boolean;
}

const ReviewModePopups: FC<ReviewModePopupsProps> = ({
  isConfirmationRequired,
  toggleReviewMode,
  presentationId,
  isShowReviewModePopUp,
  confirmReviewModeChange,
  applyReviewModeChanges,
  tmpReviewModeState
}): JSX.Element => {
  const doneBtnText = 'OK';
  const mixpanelReviewEventType = !tmpReviewModeState ? MIXPANEL_EVENT_TYPES.ON : MIXPANEL_EVENT_TYPES.OFF;


  const confirmChangeReviewMode = (): void => {
    confirmReviewModeChange(presentationId);
    toggleReviewMode();
  };

  const getNotificationBodyMessage = (): string => {
    return `<p><b>Review mode</b> was ${tmpReviewModeState ? 'enabled' : 'disabled'} by another person.</p>`;
  };

  const getConfirmationBodyMessage = (): string => {
    return `<p><b>Review mode</b> will be ${tmpReviewModeState ? 'disabled' : 'enabled'} for everyone using the Q&A page.</p>`;
  };

  const applyReviewModeChangesHandler = (cancelToggle?: boolean): void => {
    applyReviewModeChanges(cancelToggle);
    getMixpanelService().track(MIXPANEL_EVENT_IDENTIFIERS.REVIEW_MODE, mixpanelReviewEventType);
  };

  const confirmChangeReviewModeHandler = (): void => {
    confirmChangeReviewMode();
    getMixpanelService().track(MIXPANEL_EVENT_IDENTIFIERS.REVIEW_MODE, mixpanelReviewEventType);
  };

  return (
    <>
      {isShowReviewModePopUp && (
        <>
          {isConfirmationRequired
            ? <Notification
              message={getNotificationBodyMessage()}
              timeToAutoClose={NOTIFICATION_INTERVAL}
              action={() => applyReviewModeChangesHandler(true)}
              />
            : <Modal
              additionalClassNames='review-mode-modal'
              cancelAction={toggleReviewMode}
              doneAction={confirmChangeReviewModeHandler}
              htmlString={getConfirmationBodyMessage()}
              modalType={ModalTypes.CONFIRMATION}
              doneButtonText={doneBtnText}
              />
          }
        </>
      )}
    </>
  );
};

export default ReviewModePopups;
